var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.el && (_vm.el.scrollHeight-_vm.rect.height))?_c('section',{staticClass:"up-down"},[_c('i',{staticClass:"el-icon-caret-top",attrs:{"size":"32"},on:{"click":_vm.up}}),_c('i',{staticClass:"el-icon-caret-bottom",attrs:{"size":"32"},on:{"click":_vm.down}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }